module.exports = __webpack_public_path__ + "media/images/visit-us-header-m-fa93f5ad33a0b3f7974082e3e10299cb.jpg";